import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "manual-lifecycle-implementation"
    }}>{`Manual Lifecycle implementation`}</h1>
    <InlineAlert variant="info" slots="text" mdxType="InlineAlert" />
    <p>{`In Adobe Mobile Library (v4) iOS SDK, this implementation was completed automatically.`}<br />{`When upgrading to the Experience Platform SDK, you must add code to continue collecting Lifecycle metrics.`}</p>
    <p>{`Follow the `}<a parentName="p" {...{
        "href": "/client-sdks/src/pages/home/base/mobile-core/lifecycle/index.md"
      }}>{`Lifecycle implementation guide`}</a>{` which includes the following steps:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/client-sdks/src/pages/home/base/mobile-core/lifecycle/index.md#add-lifecycle-to-your-app"
        }}>{`Add Lifecycle to your app`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/client-sdks/src/pages/home/base/mobile-core/lifecycle/index.md#register-lifecycle-with-mobile-core"
        }}>{`Register Lifecycle with Mobile Core`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/client-sdks/src/pages/home/base/mobile-core/lifecycle/index.md#add-lifecycle-start-and-pause-calls"
        }}>{`Manually add Lifecycle start and pause calls to your application`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      